/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnDesktopPlatform } from './en-desktop-platform';
import { EnStationType } from './en-station-type';
import { JoinEntityDto } from './join-entity-dto';
import { UpdateStationComponentDto } from './update-station-component-dto';
 /**
 *
 *
 * @export
 * @interface UpdateStationDto
 */
export interface UpdateStationDto {

    /**
     * Human-readable name for the kiosk (e.g. \"Kiosk Floor 2 - Room 4\")
     *
     * @type {string}
     * @memberof UpdateStationDto
     */
    name: string;

    /**
     * @type {EnStationType}
     * @memberof UpdateStationDto
     */
    type: EnStationType;

    /**
     * @type {EnDesktopPlatform}
     * @memberof UpdateStationDto
     */
    platform: EnDesktopPlatform;

    /**
     * OS version (e.g. \"Windows 11 23H2\", \"Ubuntu 24.04\", \"macOS 14.4\")
     *
     * @type {string}
     * @memberof UpdateStationDto
     */
    systemVersion?: string;

    /**
     * Unity app version (e.g. \"1.0.0\")
     *
     * @type {string}
     * @memberof UpdateStationDto
     */
    appVersion?: string;

    /**
     * @type {JoinEntityDto}
     * @memberof UpdateStationDto
     */
    client?: JoinEntityDto;

    /**
     * @type {string}
     * @memberof UpdateStationDto
     */
    note?: string;

    /**
     * @type {Array<UpdateStationComponentDto | JoinEntityDto>}
     * @memberof UpdateStationDto
     */
    components: Array<UpdateStationComponentDto | JoinEntityDto>;
}
